import React, { useContext } from 'react'
import styled from 'styled-components'
import CreationToolSuperCutField from '../../../types/super-cut-field'
import { CreationCaptureInfoContext } from '../../supercut/shared/components/capture-info/manager'
import SelectListComponent from '../../select-list'
import { TagLanguagesAlt } from '../../../types/languages'
import FieldTitle from './field-title'
import SuperCutSegmentationType from '../../../types/super-cut-segmentation-type'

const Container = styled.div`
    grid-column: span 1;
    min-width: 0;
`

const SelectList = styled(SelectListComponent)`
    width: 100%;
`

type Props = {
    field: CreationToolSuperCutField
}

const getLangLabel = (language: string) => {
    if (language.endsWith('auto')) {
        return TagLanguagesAlt.find(e => e.value === language.substring(0, 2).toUpperCase())?.name + ' (auto)'
    }
    return TagLanguagesAlt.find(e => e.value === language.toUpperCase())?.name
}

const CreationCaptureCaptionLanguageField = ({ field }: Props) => {
    const { caption, segmentationType, languages, language, setLanguage, autoCaption } = useContext(
        CreationCaptureInfoContext
    )

    const setSelectedLang = (lang: string) => {
        setLanguage(lang)
    }

    const getDefaultLanguageIndex = () => {
        if (languages.includes('en-US')) {
            setLanguage('en-US')
            return languages.indexOf('en-US')
        }
        if (languages.includes('en')) {
            setLanguage('en')
            return languages.indexOf('en')
        }
        setLanguage(languages[0])
        return 0
    }

    if (segmentationType !== SuperCutSegmentationType.Caption) {
        return null
    }

    if (!autoCaption) {
        return <Container />
    }

    return (
        <Container style={caption ? { opacity: 0.5, pointerEvents: 'none' } : undefined}>
            <FieldTitle field={field} />
            <SelectList
                {...{
                    onChange: setSelectedLang,
                    value: language || languages[getDefaultLanguageIndex()],
                    options: languages.map(lang => ({
                        value: lang,
                        label: `${getLangLabel(lang)}`,
                    })),
                }}
            />
        </Container>
    )
}

export default CreationCaptureCaptionLanguageField
